import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AMMaterialTable from "src/pages/components/AMMatrialTable";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

function EmptyCard() {
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Empty card
        </Typography>
        <Typography variant="body2" gutterBottom>
          Empty card
        </Typography>
      </CardContent>
    </Card>
  );
}

function Blank() {
  return (
    <React.Fragment>
      <Helmet title="Blank" />
      <Typography variant="h3" gutterBottom display="inline">
        Blank
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} to="/">
          Dashboard
        </Link>
        <Link component={NavLink} to="/">
          Pages
        </Link>
        <Typography>Blank</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EmptyCard />
        </Grid>
        <Grid item xs={12}>
          <div style={{ maxWidth: "100%" }}>
            {/* <AMMaterialTable
              columns={[
                { title: "Adı", field: "name" },
                { title: "Soyadı", field: "surname" },
                { title: "Doğum Yılı", field: "birthYear", type: "numeric" },
                {
                  title: "Doğum Yeri",
                  field: "birthCity",
                  lookup: { 34: "İstanbul", 63: "Şanlıurfa" },
                },
              ]}
              data={[
                {
                  name: "Mehmet",
                  surname: "Baran",
                  birthYear: 1987,
                  birthCity: 63,
                },
              ]}
              title="Demo Title"
            /> */}
            <AMMaterialTable
              columns={[
                {
                  title: "Code",
                  field: "colCode",
                  cellStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                  headerStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                },
                {
                  title: "country",
                  field: "colcountry",
                  cellStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                  headerStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                },
                {
                  title: "name_Ar",
                  field: "colname_Ar",
                  cellStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                  headerStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                },
                {
                  title: "name_En",
                  field: "colname_En",
                  cellStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                  headerStyle: {
                    paddingLeft: 4,
                    paddingRight: 0,
                  },
                },
              ]}
              //  data={[]}
              title="Demo Title"
            />
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Blank;
